// 文件信息
export interface FileItem {
	imageFlag?: number;
	bizTeamId?: number;
	blobFileName: string;
	createTime: string;
	fileType: string;
	origFileName: string;
	id: number;
	remark: string | Record<string, any>;
	tmpVisitorToken: string;
	userId: string;
	visible: boolean;
	// 添加缺失的属性
	operateStatus?: number;
	costCharsNum?: number;
	transEngineCostRatio?: string;
	operateTag?: Record<string, any>;
	transEngineType?: number;
	transEngineIdName?: string;
	ocrFlag?: number;
	transReqJson?: Record<string, any>;
	finishFlag?: number;
	goOnFlag?: number;
	status?: number;
	useTerm?: boolean;
	translatedRate?: string;
	teamMemberName?: string;
	wholeCharsNum?: number;
	freeTag?: number;
	bizMemberName?: string;
	bizMemberAlias?: string;
	bizTeamId?: number | null; // 企业团队 id，企业任务非空（后端 SELECT * 返回，此前类型漏声明）
	failReason?: number | null; // 失败原因，4 = 用户主动取消（TransFailCause.CANCEL）
}

export interface EnterpriseInfo {
    id: number;
	createUid: number;
	createAccount: string;
	businessName: string;
	businessUrl: string | null;
	memberCount: number;
	serviceLevel: number | null;
	serviceEndTime: string | null;
	remainServiceWords: number | null;
	allServiceWordsDetail: string | null;
	remainPackageWords: number | null;
	allPackageWordsDetail: string | null;
	totalPackageWords: number | null;
	globalContractNo?: string | null;
	globalPlanCode?: string | null;
	globalOwnerSite?: 'VIP' | 'AI' | null;
	globalSeatLimit?: number | null;
	globalAllocationVersion?: number | null;
	/** 存量迁移与付费套餐等级分离；普通企业兼容空值。 */
	regionMode?: string | null;
	entitlementSource?: string | null;
	migrationServiceState?: 'NORMAL' | 'MIGRATING' | 'HISTORY_READONLY' | null;
	legacyMigrationNo?: string | null;
	migrationEntitlementSnapshotJson?: string | null;
	agentUid: number | null;
	remark: string | null;
	createTime: string;
	updateTime: string;
}

export interface EnterpriseMember {
    aliasName: string | null;
	bizTeamId: number;
	confirmAddTime: string;
	costWords: number;
	createTime: string;
	id: number;
	memberUid: number;
	permission: number;
	roleType: number;
	status: number;
	updateTime: string;
	userAccount: string;
	/** MEMBER 为已加入成员，INVITATION 为定向邀请占位记录。 */
	recordType?: 'MEMBER' | 'INVITATION';
	inviteStatus?: 'PENDING' | 'EXPIRED' | 'REVOKED' | null;
	invitationStatus?: 'PENDING' | 'EXPIRED' | 'REVOKED' | null;
	invitationId?: number | null;
	region?: EnterpriseSite;
	expireTime?: string | null;
	inviteTime?: string | null;
	inviteUrl?: string | null;
	token?: string | null;
}

export type EnterpriseSite = 'AI' | 'VIP'

export interface EnterpriseInviteLink {
	url?: string;
	region: EnterpriseSite;
	token: string;
	expireTime: string;
	active: boolean;
	seatUsed?: number;
	seatLimit?: number;
	remainQuota?: number;
	totalQuota?: number;
}

export interface EnterpriseTargetInvite {
	id: number;
	bizTeamId?: number;
	inviteAccount?: string;
	email?: string;
	region: EnterpriseSite;
	status: 'PENDING' | 'EXPIRED' | 'REVOKED' | 'ACCEPTED';
	aliasName?: string | null;
	roleType?: number;
	permission?: number;
	url?: string | null;
	token?: string | null;
	createTime?: string | null;
	expireTime?: string | null;
	updateTime?: string | null;
	seatUsed?: number;
	seatLimit?: number;
}

export interface EnterpriseInviteLinkList {
	global: boolean;
	links: EnterpriseInviteLink[];
	dedicatedInvites?: EnterpriseTargetInvite[];
}

export type EnterpriseBalanceAlertPlanMode = 'none' | 'local' | 'global'
export type EnterpriseBalanceAlertPool = 'LOCAL' | 'VIP' | 'AI'
export type EnterpriseBalanceAlertStatus = 'LOW' | 'EXHAUSTED'
export type EnterpriseBalanceAlertThresholdType = 'PERCENT' | 'CHARS'

export interface EnterpriseBalanceAlertConfig {
	enabled: boolean;
	thresholdType: EnterpriseBalanceAlertThresholdType;
	thresholdPercent: number | null;
	thresholdChars: number | null;
	monitorPools: EnterpriseBalanceAlertPool[];
	emailEnabled: boolean;
	bannerEnabled: boolean;
	version?: number | null;
}

export interface EnterpriseBalanceAlertPoolSummary {
	pool: EnterpriseBalanceAlertPool;
	label?: string | null;
	domain?: string | null;
	remainingWords: number;
	totalWords: number;
	thresholdChars: number;
	thresholdPercent?: number | null;
	status: EnterpriseBalanceAlertStatus;
	cycleId: string;
	dismissible: boolean;
	dismissed?: boolean;
}

export interface EnterpriseBalanceAlertResponse {
	canManage: boolean;
	planMode: EnterpriseBalanceAlertPlanMode;
	currentPool?: EnterpriseBalanceAlertPool | null;
	config: EnterpriseBalanceAlertConfig;
	pools?: Array<{
		pool: EnterpriseBalanceAlertPool;
		label?: string | null;
		domain?: string | null;
		totalWords: number;
		remainingWords: number;
	}>;
	alerts: EnterpriseBalanceAlertPoolSummary[];
}

export interface EnterpriseBalanceAlertSaveParams extends EnterpriseBalanceAlertConfig {}

export interface EnterpriseBalanceAlertDismissParams {
	pool: EnterpriseBalanceAlertPool;
	cycleId: string;
}

export interface PrioritySupportDomesticConfig {
	wechatGroupQrUrl: string;
	wechatBackupId: string;
	qqGroupQrUrl: string;
	qqGroupNumber: string;
	email: string;
}

export interface PrioritySupportInternationalConfig {
	xAccount: string;
	xUrl: string;
	email: string;
}

export interface PrioritySupportConfig {
	domestic: PrioritySupportDomesticConfig;
	international: PrioritySupportInternationalConfig;
}

export interface PresetTermHeader {
	presetKey: string;
	termName: string;
	entryNum: number;
	exist: boolean;
	sourceLang: string;
	targetLang: string;
}

export interface PresetTermEntry {
	entryKey: string;
	entryValue: string;
}

export const EnterpriseMemberPermission = {
	FILE_LOOK: 1,        // 二进制"1" - [文件]查看
	FILE_DOWNLOAD: 2,    // 二进制"10" - [文件]下载
	FILE_EDIT: 4,        // 二进制"100" - [文件]编辑
	TERM_USE: 8,         // 二进制"1000" - [术语表]使用
	TERM_EDIT: 16,       // 二进制"10000" - [术语表]编辑
};

// 权限检查函数
export const PermissionUtils = {
	/**
	 * 检查用户是否拥有指定权限
	 * @param userPermission 用户的权限值
	 * @param requiredPermission 需要检查的权限
	 * @returns 是否拥有权限
	 */
	hasPermission: (userPermission: number, requiredPermission: number): boolean => {
		return (userPermission & requiredPermission) === requiredPermission;
	},

	/**
	 * 添加权限
	 * @param currentPermission 当前权限值
	 * @param permissionToAdd 要添加的权限
	 * @returns 新的权限值
	 */
	addPermission: (currentPermission: number, permissionToAdd: number): number => {
		console.log('asdasdsad==', currentPermission, permissionToAdd)
		return currentPermission | permissionToAdd;
	},

	/**
	 * 移除权限
	 * @param currentPermission 当前权限值
	 * @param permissionToRemove 要移除的权限
	 * @returns 新的权限值
	 */
	removePermission: (currentPermission: number, permissionToRemove: number): number => {
		return currentPermission & ~permissionToRemove;
	},

	/**
	 * 获取权限描述
	 * @param permission 权限值
	 * @returns 权限描述数组
	 */
	getPermissionDescriptions: (permission: number): string[] => {
		const descriptions: string[] = [];
		
		if (permission & EnterpriseMemberPermission.FILE_LOOK) {
			descriptions.push("[文件]查看");
		}
		if (permission & EnterpriseMemberPermission.FILE_DOWNLOAD) {
			descriptions.push("[文件]下载");
		}
		if (permission & EnterpriseMemberPermission.FILE_EDIT) {
			descriptions.push("[文件]编辑");
		}
		if (permission & EnterpriseMemberPermission.TERM_USE) {
			descriptions.push("[术语表]使用");
		}
		if (permission & EnterpriseMemberPermission.TERM_EDIT) {
			descriptions.push("[术语表]编辑");
		}
		
		return descriptions;
	},

	/**
	 * 检查是否拥有所有指定权限
	 * @param userPermission 用户的权限值
	 * @param requiredPermissions 需要检查的权限数组
	 * @returns 是否拥有所有权限
	 */
	hasAllPermissions: (userPermission: number, requiredPermissions: number[]): boolean => {
		return requiredPermissions.every(permission => 
			PermissionUtils.hasPermission(userPermission, permission)
		);
	},

	/**
	 * 检查是否拥有任意一个指定权限
	 * @param userPermission 用户的权限值
	 * @param requiredPermissions 需要检查的权限数组
	 * @returns 是否拥有任意一个权限
	 */
	hasAnyPermission: (userPermission: number, requiredPermissions: number[]): boolean => {
		return requiredPermissions.some(permission => 
			PermissionUtils.hasPermission(userPermission, permission)
		);
	}
};
